import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useFormContext, useFieldArray } from 'react-hook-form';
import Input from 'components/common/Input';
import Flex from 'components/common/Flex';
import Avatar from 'components/common/Avatar';
import SimpleBarReact from 'simplebar-react';
import IconButton from 'components/common/IconButton';
import UploadFiles from 'components/common/UploadFiles';
import FalconLightBox from 'components/common/FalconLightBox';

const ImageForm = ({ index, propIndex }) => {
 const { watch, setValue } = useFormContext();
 const nameImg = `references.${index}.properties.${propIndex}.images`;
 const images = watch(nameImg) ?? [];

 const deleteImage = index => {
  const deletImages = images.filter((_, i) => i !== index);
  setValue(nameImg, deletImages);
 };

 return images.length ? (
  <SimpleBarReact className="mx-1" forceVisible="x" autoHide={true} style={{ whiteSpace: 'nowrap', overflowX: 'auto' }}>
   <Flex className="mb-2">
    {images.map((image, i) => (
     <Flex key={'img_' + i} className="rounded-3 border bg-300 mx-1" wrap="nowrap">
      <FalconLightBox image={image?.preview ?? image} className="d-flex align-items-center">
       <Avatar src={image?.preview ?? image} alt={image?.path ?? ''} rounded="start" size="3xl" />
      </FalconLightBox>
      <a className="cursor-pointer text-danger align-self-stretch" onClick={() => deleteImage(i)}>
       <FontAwesomeIcon className="fs--1 mx-1" icon="trash-alt" />
      </a>
     </Flex>
    ))}
   </Flex>
  </SimpleBarReact>
 ) : (
  <></>
 );
};

const ArticlePropertyForm = ({ index }) => {
 const { control, register, errors, setValue, getValues } = useFormContext();
 const { fields, append, remove } = useFieldArray({
  control,
  name: `references.${index}.properties`
 });

 return (
  <>
   {fields.map((_, i) => (
    <div key={'prop_' + i} className="bg-100 rounded-3 mb-3">
     <Flex justifyContent="between" className="mb-2" wrap="nowrap">
      <Flex justifyContent="start" alignItems="center" alignContent="center" wrap="nowrap">
       <Input
        type="text"
        errors={errors}
        formGroupProps={{ className: 'mx-1' }}
        name={`references.${index}.properties.${i}.name`}
        formControlProps={{ ...register(`references.${index}.properties.${i}.name`), size: 'sm' }}
       />

       <Input
        type="color"
        errors={errors}
        formGroupProps={{ className: 'mx-1' }}
        name={`references.${index}.properties.${i}.color`}
        formControlProps={{ ...register(`references.${index}.properties.${i}.color`), size: 'sm' }}
       />

       <UploadFiles
        noFiles={true}
        multiple={true}
        accept="image/*"
        classInput="references"
        dropzoneArea={false}
        onChange={imgs => {
         const nameImg = `references.${index}.properties.${i}.images`;
         const images = getValues(nameImg) ?? [];
         setValue(nameImg, [...images, ...imgs]);
        }}
        placeholder={
         <Button variant="falcon-success" type="button" className="m-1 icon-item icon-item-sm">
          <FontAwesomeIcon icon="images" className="fs-1" />
         </Button>
        }
       />
      </Flex>

      <Button type="button" variant="falcon-danger" className="m-1 icon-item icon-item-sm" onClick={() => remove(i)}>
       <FontAwesomeIcon icon="trash" className="" />
      </Button>
     </Flex>

     <ImageForm index={index} propIndex={i} />
    </div>
   ))}

   <IconButton
    size="sm"
    icon="plus"
    type="button"
    children="Agregar item"
    variant="falcon-success"
    className="mb-3 float-end"
    onClick={() => append({ name: '', color: '', images: [] })}
   />
  </>
 );
};

ImageForm.propTypes = {
 index: PropTypes.number.isRequired,
 propIndex: PropTypes.number.isRequired
};

ArticlePropertyForm.propTypes = { index: PropTypes.number.isRequired };

export default ArticlePropertyForm;
